var _defs, _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.28,37.09l57.86-.06c3.15.37,5.6,2.79,6.33,5.85.4,19.49.4,39.12,0,58.61-.74,3.08-3.14,5.42-6.32,5.85h-57.33c-4.3-.74-6.31-3.76-6.58-7.95v-55.17c.3-3.5,2.61-6.33,6.05-7.12ZM40.97,43.81v15.12l.29.29h14.72c8.31-9.9,24.65-9.86,32.98,0h14.72l.29-.29v-14.72c0-1.5-1.82-3.54-3.43-3.44h-56.34c-1.46.06-3.01,1.67-3.24,3.05ZM90.95,74.02c0-10.22-8.28-18.51-18.5-18.51s-18.5,8.29-18.5,18.51,8.28,18.51,18.5,18.51,18.5-8.29,18.5-18.51ZM53.14,62.96h-12.17v37.4c0,1.46,2.05,3.5,3.62,3.25h56.15c1.36.05,3.24-2,3.24-3.25v-37.4h-12.17c1.29,2.64,2.35,5.43,2.72,8.37,1.28,9.97-4.72,19.83-14.01,23.44-17.05,6.64-34.35-9.17-29.45-26.71.5-1.78,1.3-3.44,2.06-5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.17,44.36c1.53-.22,5.24-.21,6.82-.05,1.35.14,2.1.64,2.26,2.06s.18,6.53-.13,7.72c-.24.91-.79,1.3-1.72,1.42-1.24.15-6.92.17-7.96-.1-.83-.22-1.28-.94-1.37-1.77-.18-1.49-.19-5.98.02-7.45.17-1.21.94-1.66,2.09-1.83ZM96.52,48.04h-3.44l-.29.29v3.44h3.73v-3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.27,74.04c0,8.18-6.63,14.81-14.81,14.81s-14.81-6.63-14.81-14.81,6.63-14.81,14.81-14.81,14.81,6.63,14.81,14.81ZM83.55,74.04c0-6.13-4.97-11.1-11.09-11.1s-11.09,4.97-11.09,11.1,4.97,11.1,11.09,11.1,11.09-4.97,11.09-11.1Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 72.5,
    cy: 72.19,
    r: 67.95
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/InstagramIcon.098019a0bb72b5517f1ab39c92ab1557.svg";
export { ForwardRef as ReactComponent };